import type { ApiConfig } from '../../types'

/**
 * Backpack の perp ファンディング履歴 API 設定。
 * `/wapi/v1/history/funding` (instruction: fundingHistoryQueryAll) を利用する。
 *
 * 本 endpoint は `from` / `to` フィルタをサポートせず、offset ベースの pagination のみ。
 * このため `fetchApiData` 内部で全ページを取得する設計とし、 `limit` には framework の
 * "count < limit ⇒ 全取得済" 判定が常に成立する大きな値を設定する。
 */
export const fundingHistoryApiConfig = {
  existSubType: false,
  fetchableRange: undefined,
  limit: 1_000_000,
  order: 'desc',
  range: undefined,
  requiresRange: false,
  type: 'funding-history',
} as const satisfies ApiConfig
